var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("cancel-modal", {
        attrs: {
          "modal-id": "subscription-cancel-modal",
          visible: _vm.showCancelModal,
          title: _vm.$t("subscription.cancel_confirm_title"),
          message: _vm.cancelMessage,
          "justification-label": _vm.$t("subscription.cancellation_reason"),
          "justification-placeholder": _vm.$t(
            "subscription.cancel_reason_placeholder"
          ),
          "ok-title": _vm.$t("action.confirm"),
          "cancel-title": _vm.$t("action.cancel"),
        },
        on: {
          confirm: _vm.doCancel,
          cancel: function ($event) {
            _vm.showCancelModal = false
          },
          "update:visible": function ($event) {
            _vm.showCancelModal = $event
          },
        },
      }),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "subscriptions",
          route_grid_path: "/grid",
          order_column: "id",
          "fetch-on-mounted": false,
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-wrap gap-3 items-end w-full" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "subscriptions.create",
                            expression: "'subscriptions.create'",
                          },
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { 400: true },
                          },
                        ],
                        attrs: { variant: "primary" },
                        on: { click: _vm.addNew },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "PlusIcon" },
                        }),
                        _c("span", { staticClass: "align-middle" }, [
                          _vm._v(_vm._s(_vm.$t("AddNew"))),
                        ]),
                      ],
                      1
                    ),
                    _c("SubscriptionFilter", {
                      on: { change: _vm.handleFilterChange },
                      model: {
                        value: _vm.filters,
                        callback: function ($$v) {
                          _vm.filters = $$v
                        },
                        expression: "filters",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v(_vm._s(_vm.$t("subscription.id"))),
                ]),
                _c("vs-th", { key: "user", attrs: { "sort-key": "user_id" } }, [
                  _vm._v(_vm._s(_vm.$t("subscription.user"))),
                ]),
                _c(
                  "vs-th",
                  {
                    key: "plan",
                    attrs: { "sort-key": "subscription_plan_id" },
                  },
                  [_vm._v(_vm._s(_vm.$t("subscription.plan")))]
                ),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("subscription.status")))]
                ),
                _c(
                  "vs-th",
                  { key: "started_at", attrs: { "sort-key": "started_at" } },
                  [_vm._v(_vm._s(_vm.$t("subscription.started_at")))]
                ),
                _c(
                  "vs-th",
                  { key: "ends_at", attrs: { "sort-key": "ends_at" } },
                  [_vm._v(_vm._s(_vm.$t("subscription.ends_at")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")]),
                    ]),
                    _c("vs-td", { key: "user", attrs: { width: "20%" } }, [
                      _c("div", [
                        _vm._v(" " + _vm._s(tr.user ? tr.user.name : "-")),
                      ]),
                    ]),
                    _c("vs-td", { key: "plan", attrs: { width: "20%" } }, [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              tr.subscription_plan
                                ? tr.subscription_plan.name
                                : "-"
                            )
                        ),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "15%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.getStatusColor(tr.status),
                            },
                          },
                          [_vm._v(_vm._s(tr.status_label))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "started_at", attrs: { width: "15%" } },
                      [
                        _c("div", [
                          _vm._v(
                            " " + _vm._s(_vm.formatDate(tr.started_at)) + " "
                          ),
                        ]),
                      ]
                    ),
                    _c("vs-td", { key: "ends_at", attrs: { width: "15%" } }, [
                      _c("div", [
                        _vm._v(" " + _vm._s(_vm.formatDate(tr.ends_at)) + " "),
                      ]),
                    ]),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2 items-center" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "subscriptions.show",
                                expression: "'subscriptions.show'",
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: _vm.$t("action.consult"),
                                  delay: { show: 100, hide: 100 },
                                },
                                expression:
                                  "{\n                content: $t('action.consult'),\n                delay: { show: 100, hide: 100 }\n              }",
                                modifiers: { top: true },
                              },
                            ],
                            staticClass:
                              "h-5 w-5 stroke-current text-primary cursor-pointer",
                            attrs: { icon: "EyeIcon" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  name: "subscription-detail",
                                  params: { id: tr.id },
                                })
                              },
                            },
                          }),
                          _vm.canEdit(tr)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "subscriptions.edit",
                                    expression: "'subscriptions.edit'",
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$t("action.edit"),
                                    expression: "$t('action.edit')",
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 stroke-current text-warning cursor-pointer",
                                attrs: { icon: "EditIcon" },
                                on: {
                                  click: function ($event) {
                                    return props.edit(props.data[indextr].id)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.canCancel(tr)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "subscriptions.cancel",
                                    expression: "'subscriptions.cancel'",
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$t("subscription.cancel_action"),
                                    expression:
                                      "$t('subscription.cancel_action')",
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 stroke-current text-danger cursor-pointer",
                                attrs: { icon: "XCircleIcon" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmCancel(tr)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.canDelete(tr)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "subscriptions.delete",
                                    expression: "'subscriptions.delete'",
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$t("action.delete"),
                                    expression: "$t('action.delete')",
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 stroke-current text-danger cursor-pointer",
                                attrs: { icon: "Trash2Icon" },
                                on: {
                                  click: function ($event) {
                                    return props.destroy(props.data[indextr])
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }